const welcome = {
    title: 'Добро пожаловать в административную консоль',
    description: 'Административная консоль - это веб-приложение для управления JX Account без требований к кодированию. Давайте сначала создадим учетную запись. С этой учетной записью вы можете управлять JX Account самостоятельно или от имени вашей компании.',
    create_account: 'Создать учетную запись',
};
export default Object.freeze(welcome);
